import axios from 'axios';
import { action, Module, mutation, VuexModule } from 'vuex-class-component';
import { vxm } from '@/store.vuex';
@Module({ namespacedPath: 'roleSignup/' })
export class RoleSignup extends VuexModule {
  private pilotLicenseCategories: Array<any> = [];
  private engineerLicenceCategories: Array<any> = [];
  private pilotFleetOptions: Array<any> = [];
  private engineerFleetOptions: Array<any> = [];
  private equipmentTypeOptions: Array<any> = [];
  private pilotRankOptions: Array<any> = [];
  private engineerRankOptions: Array<any> = [];
  private marketingEmail: boolean = false;
  private childCompanies: Array<any> = [];
  private customFieldMappings = {
    rank: '',
    fleet: '',
    hour: '',
    role: '',
    aircraftAirframe: '',
    equipmentType: '',
    lastFlightDate: '',
  };

  public async pioletSignup() {}
  public async engineerSignup() {}

  get PilotLicenseCategories() {
    return this.pilotLicenseCategories;
  }

  get EngineerLicenceCategories() {
    return this.engineerLicenceCategories;
  }

  get PilotFleetOptions() {
    return this.pilotFleetOptions;
  }

  get EngineerFleetOptions() {
    return this.engineerFleetOptions;
  }

  get PilotRankOptions() {
    return this.pilotRankOptions;
  }

  get EngineerRankOptions() {
    return this.engineerRankOptions;
  }

  get CustomFieldMappings() {
    return this.customFieldMappings;
  }

  get EquipmentTypeOptions() {
    return this.equipmentTypeOptions;
  }

  get ChildCompanies() {
    return this.childCompanies;
  }

  get MarketingEmail() {
    return this.marketingEmail;
  }

  @mutation
  public setMarketingMail(payload) {
    this.marketingEmail = payload;
  }

  @mutation
  public setPilotFleetOptions(payload) {
    this.pilotFleetOptions = payload;
  }

  @mutation
  public setEngineerFleetOptions(payload) {
    this.engineerFleetOptions = payload;
  }

  @mutation
  public setEquipmentTypeOptions(payload) {
    this.equipmentTypeOptions = payload;
  }

  @mutation
  public setPilotRankOptions(payload) {
    this.pilotRankOptions = payload;
  }

  @mutation
  public setEngineerRankOptions(payload) {
    this.engineerRankOptions = payload;
  }

  @mutation
  public setPilotLicenseCategories(payload) {
    this.pilotLicenseCategories = payload;
  }

  @mutation
  public setEngineerLicenceCategories(payload) {
    this.engineerLicenceCategories = payload;
  }

  @mutation
  public setCustomFieldMappings(payload) {
    this.customFieldMappings = payload;
  }

  @mutation
  public setChildCompanies(payload) {
    this.childCompanies = payload;
  }

  @action({ mode: 'mutate' })
  public async basicSignup(payload) {
    payload.companyCode = vxm.jobs.BrandingInfo.companycode;
    payload.userName = payload.email;
    payload.doNotTriggerEvent = 'true';
    const response = await axios.post(
      '/wl-sso-sec-svc/api/user/register',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    if (response.data.jwt && response.data.jwt.accessToken) {
      vxm.users.setAuthStatus(true);
      vxm.users.setToken(response.data.jwt.accessToken.token);
      vxm.users.setRefreshToken(response.data.jwt.refreshToken.token);
    }
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async uploadResume(payload) {
    const resumePayload = JSON.stringify({
      resumename: '',
      jobpostingid: -1,
      resumeLink: '',
    });
    const formData = new FormData();
    var resumeName = payload.resume.resumename;
    if (resumeName && resumeName.includes("'")) {
      resumeName = resumeName.replace(/'/g, '0011111111111111100');
    }
    formData.append('resumefile', payload.resumefile, resumeName);
    formData.append('resume', resumePayload);
    formData.append('doNotTriggerEvent', 'true');
    const response = await axios.post(
      '/wl-profile-svc/api/user-profile/resume',
      formData,
      {
        headers: { Authorization: `Bearer ${vxm.users.getToken}` },
      },
    );
    return response;
  }

  @action({ mode: 'mutate' })
  public async saveUserProfile(
    { dob, totalFlightHours } = { dob: null, totalFlightHours: '' },
  ) {
    await vxm.users.refreshProfileInfo();
    const userProfile = vxm.users.myUserProfile;
    userProfile.dob = dob || userProfile.dob;
    userProfile.totalFlightHours =
      totalFlightHours || userProfile.totalFlightHours;
    userProfile.notificationTypeMap = {
      ...userProfile.notificationTypeMap,
      MARKETING_EMAIL: this.marketingEmail,
    };
    const response = await vxm.users.saveUserProfile({
      userProfile,
      isPartofRegistration: true,
    });
    return response;
  }

  @action({ mode: 'mutate' })
  public async fetchPilotLicenseCategory() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/licences/category/Pilot',
    );
    this.setPilotLicenseCategories(
      response.data.data.licences.map((opt) => {
        return { text: opt.name, value: opt.masterId };
      }),
    );
  }

  @action({ mode: 'mutate' })
  public async fetchEngineerLicenseCategory() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/licences/category/Engineer',
    );
    this.setEngineerLicenceCategories(
      response.data.data.licences.map((opt) => {
        return { text: opt.name, value: opt.masterId };
      }),
    );
  }

  @action({ mode: 'mutate' })
  public async saveLicenceInfo(payload) {
    payload.documents = [];
    payload.doNotTriggerEvent = 'true';
    const formData = new FormData();
    formData.append('licenceInfo', JSON.stringify(payload));
    const response = await axios.post(
      '/wl-profile-svc/api/v1/userLicences',
      formData,
      {
        headers: { Authorization: `Bearer ${vxm.users.getToken}` },
      },
    );
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async fetchJobHistoryMetaData() {
    const response = await axios.get(
      `/wl-profile-svc/api/v2/jobHistoryMetaData?companyCode=${
        vxm.jobs.BrandingInfo.companycode
      }`,
    );
    const pilotFleetField = response.data.data.jobHistoryMetaData.find(
      (field) =>
        field.label === 'Fleet' &&
        response.data.data.profiles[0].fields.includes(field.id),
    );
    const engineerFleetField = response.data.data.jobHistoryMetaData.find(
      (field) =>
        field.label === 'Aircraft/Airframe' &&
        response.data.data.profiles[1].fields.includes(field.id),
    );
    const pilotRankField = response.data.data.jobHistoryMetaData.find(
      (field) =>
        field.label === 'Rank' &&
        response.data.data.profiles[0].fields.includes(field.id),
    );
    const engineerRankField = response.data.data.jobHistoryMetaData.find(
      (field) =>
        field.label === 'Rank' &&
        response.data.data.profiles[1].fields.includes(field.id),
    );
    const hourField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'Total Hours on Fleet in Rank',
    );
    const jobRoleField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'What is your job role?',
    );
    const aircraftAirframeField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'Aircraft/Airframe',
    );
    const equipmentTypeField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'Engine Type',
    );
    const lastFlightDateField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'Date of Last Flight',
    );
    const customFieldMapping = {
      rank: pilotRankField.name,
      fleet: pilotFleetField.name,
      hour: hourField.name,
      role: jobRoleField.name,
      aircraftAirframe: aircraftAirframeField.name,
      equipmentType: equipmentTypeField.name,
      lastFlightDate: lastFlightDateField.name,
    };
    this.setPilotRankOptions(
      pilotRankField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setEngineerRankOptions(
      engineerRankField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setPilotFleetOptions(
      pilotFleetField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setEngineerFleetOptions(
      engineerFleetField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setEquipmentTypeOptions(
      equipmentTypeField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setCustomFieldMappings(customFieldMapping);
  }

  @action({ mode: 'mutate' })
  public async saveJobHistory(payload) {
    payload.doNotTriggerEvent = 'true';
    const response = await axios.post(
      '/wl-profile-svc/api/v1/jobHistory',
      payload,
      {
        headers: { Authorization: `Bearer ${vxm.users.getToken}` },
      },
    );
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async fetchChildCompanies() {
    const response = await axios.post(
      `/wl-jobs-svc/api/v1/jobHistory/company/${
        vxm.jobs.BrandingInfo.companycode
      }`,
    );
    this.setChildCompanies(response.data);
  }

  @action({ mode: 'mutate' })
  public async triggerMegaEvent(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/user-profile/triggerMegaIntegrationEvent',
      {
        sections: payload,
      },
      {
        headers: { Authorization: `Bearer ${vxm.users.getToken}` },
      },
    );
  }

  @action({ mode: 'mutate' })
  public async megaSignup(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/v2/megaSignup',
      payload,
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data;
  }
}
